export const structure = {
label: 'STRUCTURE',
title: 'Defined Leadership.',
subtitle: 'A straightforward corporate structure designed to support accountability, efficient operations, and long-term business development.',

entity_1_label: 'CORPORATE ENTITY',
entity_1_name: 'One More Global Inc.',
entity_1_role: 'U.S. Corporation',
entity_1_location: 'Houston, Texas, USA',
entity_1_desc: 'Responsible for its business operations, product distribution, market development, strategic partnerships, and organizational growth.',

hierarchy_title: 'Organizational Hierarchy',
hierarchy_level_1: 'Chief Executive Officer (CEO)',
hierarchy_level_1_desc: 'Alper Volkan Karpuz provides overall strategic direction and executive leadership.',
hierarchy_level_2: 'Executive & Operational Leadership',
hierarchy_level_2_desc: 'Senior leaders managing technology, operations, expansion, and administrative functions.',

leadership_title: 'Corporate Leadership',
diagram_title: 'Leadership Structure',
entity_table_title: 'Company Overview',
};
